import type { ChatMessage } from '@/entities/chatMessage/model/types';

export interface CachedChatSession {
  messages: ChatMessage[];
  feedbackGiven: Record<string, boolean>;
  turnIndex: number;
}

// Keep conversation text only in memory, never in localStorage or sessionStorage.
const sessions = new Map<string, CachedChatSession>();

export function chatSessionKey(familyId: string, memberId: string | null): string {
  return `${familyId}:${memberId ?? 'family'}`;
}

export function readChatSession(key: string): CachedChatSession | undefined {
  return sessions.get(key);
}

export function writeChatSession(key: string, session: CachedChatSession): void {
  sessions.set(key, session);
}

export function clearChatSessions(): void {
  sessions.clear();
}
